import {css} from 'lit';
export const styles = css`:host {
  --trigger-margin: 8px;
}

.inner {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  line-height: normal;
}

.truncated {
  margin-bottom: var(--trigger-margin);
}
`;
export default styles;
